<template>
  <div v-if="isHideRevenue !== undefined" class="wrapper">
    <StandardReportBreadCrumb class="breadCrumb" />
    <Section class="chart-wrapper">
      <Chart :chartData="dailyReportData" :is-hide-revenue="isHideRevenue" />
    </Section>
    <Section class="table-wrapper">
      <div class="selector-wrapper">
        <v-flex xs2 pl-2>
          <PeriodSelector :period="period" :calendar-range="calendarRange" />
        </v-flex>
        <v-flex xs2 pl-3 pt-2>
          <IOSelector
            v-model="selectedInsertionOrderIds"
            :report-data="reportData"
          />
        </v-flex>
      </div>
      <MainTable
        :report-data="reportData"
        :range="range"
        :selected-insertion-order-ids="selectedInsertionOrderIds"
        :selected-billing-period-ids="selectedBillingPeriodIds"
        :is-hide-revenue="isHideRevenue"
      />
    </Section>
  </div>
</template>

<script>
import isEqual from 'lodash/isEqual'
import { mapState, mapGetters, mapActions } from 'vuex'
import { setDrawerTypeAdvertiser } from '@/mixins/setDrawerTypeAdvertiser'
import { setToolbarTypeAdvertiser } from '@/mixins/setToolBarTypeAdvertiser'

import StandardReportBreadCrumb from '@/components/Shared/BreadCrumb/StandardReportBreadCrumb'
import Chart from '@/components/Advertiser/Report/StandardReport/Chart'
import PeriodSelector from '@/components/Advertiser/Report/StandardReport/PeriodSelector'
import IOSelector from '@/components/Advertiser/Report/StandardReport/IOSelector'
import MainTable from '@/components/Advertiser/Report/StandardReport/MainTable'
import Section from '@/components/Shared/Section/Section'
import { Account } from '@/models/Account'

const namespace = 'advertiser/standardReport'

export default {
  name: 'StandardReport',
  components: {
    Chart,
    IOSelector,
    PeriodSelector,
    StandardReportBreadCrumb,
    Section,
    MainTable,
  },
  mixins: [setDrawerTypeAdvertiser, setToolbarTypeAdvertiser],
  data() {
    return {
      watcher: null,
      isHideRevenue: undefined,
    }
  },
  computed: {
    ...mapState(namespace, [
      'loading',
      'period',
      'calendarRange',
      'selectedInsertionOrderIds',
      'selectedBillingPeriodIds',
      'insertionOrders',
    ]),
    ...mapGetters(namespace, ['range', 'reportData', 'dailyReportData']),
    userBelongType() {
      return this.$store.getters['account/belongType']
    },
    userBelongId() {
      return this.$store.getters['account/belongId']
    },
    userType() {
      return this.$store.getters['account/userType']
    },
  },
  watch: {
    async userBelongType() {
      this.setIsHideRevenue()
    },
  },
  async created() {
    this.showLoader()
    this.watchReportParams()

    this.clearSelection()
    await this.fetchReportData()
    this.resetSelection()
    this.hideLoader()
    this.setIsHideRevenue()
  },
  beforeDestroy() {
    this.unwatchReportParams()
  },
  methods: {
    ...mapActions(namespace, {
      fetchReportData: 'FETCH_REPORT_DATA',
      clearSelection: 'CLEAR_SELECTION',
      resetSelection: 'RESET_SELECTION',
    }),
    ...mapActions('loader', {
      showLoader: 'SHOW',
      hideLoader: 'HIDE',
    }),
    async setIsHideRevenue() {
      if (!this.userBelongType || !this.userBelongId) return

      this.isHideRevenue = await Account.isHideRevenue(
        this.userBelongType,
        this.userBelongId,
        this.userType,
      )
    },
    watchReportParams() {
      this.watcher = this.$watch(
        () => [
          this.range,
          this.selectedInsertionOrderIds,
          this.selectedBillingPeriodIds,
        ],
        async ([newRange], [oldRange]) => {
          this.showLoader()
          if (!isEqual(newRange, oldRange)) {
            // 期間変更時はIO、BP選択をリセットする
            this.clearSelection()
            await this.fetchReportData()
            this.resetSelection()
          } else {
            this.fetchReportData()
          }
          this.hideLoader()
        },
        { deep: true },
      )
    },
    unwatchReportParams() {
      this.watcher && this.watcher()
    },
  },
}
</script>

<style scoped lang="scss">
.breadCrumb {
  margin-bottom: 20px;
}
.standard-title {
  margin-bottom: 30px;
  font-weight: normal;
  display: flex;
  align-items: center;
}

.title-selector {
  margin-right: 10px;
}

.chart-wrapper {
  padding: 10px 10px 20px;
}

.table-wrapper {
  margin: 30px 0 60px;
}

.wrapper {
  width: 100%;
}

.selector-wrapper {
  display: flex;
}
</style>
